import React from 'react'
import { PixelTable } from 'pixel-base'
import FinancePageShell from '../../components/FinancePageShell'

interface Props {
  title: string
  rows: Record<string, any>[]
  columns: {
    name: string
    selector: (row: Record<string, any>) => string | number | React.ReactNode
  }[]
  isLoading?: boolean
}

const ReportTablePage: React.FC<Props> = ({
  title,
  rows,
  columns,
  isLoading,
}) => {
  return (
    <FinancePageShell title={title} isLoading={isLoading}>
      <PixelTable columns={columns} data={rows} searchable pagination />
    </FinancePageShell>
  )
}

export default ReportTablePage
